/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListAssistantMemoriesResult,
  ListAssistantMemoriesResult$inboundSchema,
} from "../components/listassistantmemoriesresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListAssistantMemoriesSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListAssistantMemoriesRequest = {
  /**
   * The assistant ID.
   */
  assistantId: string;
  /**
   * Optional tags to filter memories by.
   */
  tags?: Array<string> | undefined;
  /**
   * Whether to include soft-deleted memories.
   */
  includeDeleted?: boolean | undefined;
  /**
   * The cursor to fetch results from.
   */
  cursor?: string | undefined;
  /**
   * The number of memories to return per page.
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type ListAssistantMemoriesResponse = {
  result: ListAssistantMemoriesResult;
};

/** @internal */
export type ListAssistantMemoriesSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAssistantMemoriesSecurity$outboundSchema: z.ZodMiniType<
  ListAssistantMemoriesSecurity$Outbound,
  ListAssistantMemoriesSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listAssistantMemoriesSecurityToJSON(
  listAssistantMemoriesSecurity: ListAssistantMemoriesSecurity,
): string {
  return JSON.stringify(
    ListAssistantMemoriesSecurity$outboundSchema.parse(
      listAssistantMemoriesSecurity,
    ),
  );
}

/** @internal */
export type ListAssistantMemoriesRequest$Outbound = {
  assistant_id: string;
  tags?: Array<string> | undefined;
  include_deleted: boolean;
  cursor?: string | undefined;
  limit: number;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListAssistantMemoriesRequest$outboundSchema: z.ZodMiniType<
  ListAssistantMemoriesRequest$Outbound,
  ListAssistantMemoriesRequest
> = z.pipe(
  z.object({
    assistantId: z.string(),
    tags: z.optional(z.array(z.string())),
    includeDeleted: z._default(z.boolean(), false),
    cursor: z.optional(z.string()),
    limit: z._default(z.int(), 50),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      assistantId: "assistant_id",
      includeDeleted: "include_deleted",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listAssistantMemoriesRequestToJSON(
  listAssistantMemoriesRequest: ListAssistantMemoriesRequest,
): string {
  return JSON.stringify(
    ListAssistantMemoriesRequest$outboundSchema.parse(
      listAssistantMemoriesRequest,
    ),
  );
}

/** @internal */
export const ListAssistantMemoriesResponse$inboundSchema: z.ZodMiniType<
  ListAssistantMemoriesResponse,
  unknown
> = z.pipe(
  z.object({
    Result: ListAssistantMemoriesResult$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function listAssistantMemoriesResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListAssistantMemoriesResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAssistantMemoriesResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAssistantMemoriesResponse' from JSON`,
  );
}
